import { render, staticRenderFns } from "./UpgradePlan.vue?vue&type=template&id=1db2cbae&scoped=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlan.vue?vue&type=style&index=0&id=1db2cbae&prod&scoped=true&lang=css"
import style1 from "./UpgradePlan.vue?vue&type=style&index=1&id=1db2cbae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2cbae",
  null
  
)

export default component.exports